import styled from 'styled-components';

export const Clamp = styled.div<{lines: number}>`
  /* This property doesn't exists without -webkit prefix, but it is compatible even on browsers not based on webkit */
  display: -webkit-box;
  -webkit-line-clamp: ${({lines}) => lines};
  -webkit-box-orient: vertical;
  word-break: break-all;
  overflow: hidden;
`;
